import { RevealLines, SectionLabel, FadeUp } from "./motion";
import { MagneticButton } from "./Buttons";
import { CONTACT } from "@/lib/content";

export const CTA = () => (
  <section data-testid="cta-section" className="relative overflow-hidden py-32 md:py-48">
    <div className="cta-glow pointer-events-none absolute inset-0" />
    <div className="dot-grid pointer-events-none absolute inset-0 opacity-40" />
    <div className="relative mx-auto max-w-[1440px] px-6 md:px-10">
      <SectionLabel>Next move</SectionLabel>
      <RevealLines
        inView
        as="h2"
        lines={["Have a system", "that needs", "building?"]}
        className="mt-8 font-display text-5xl font-semibold uppercase leading-[0.92] tracking-[-0.03em] text-cream sm:text-6xl lg:text-[8rem]"
        lineClass={(i) => (i === 2 ? "text-gradient" : "")}
      />
      <FadeUp delay={0.3} className="mt-14 flex flex-col gap-8 md:flex-row md:items-center md:justify-between">
        <p className="max-w-md font-body text-base text-cream/75 md:text-lg">
          Tell us what you are trying to fix. We will come back with a scoped, phased plan — and a fixed price for each phase.
        </p>
        <div className="flex flex-wrap items-center gap-4">
          <MagneticButton to="/contact" testid="cta-start-project">Start a project</MagneticButton>
          <MagneticButton href={`mailto:${CONTACT.email}`} variant="ghost" testid="cta-email">Email us</MagneticButton>
        </div>
      </FadeUp>
    </div>
  </section>
);
